/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
	ContextMenu
} from 'ca-ui-toolkit';
import '../../../stylesheets/all.scss';

export default class ContextMenuWrapper extends Component {
	constructor(props) {
		super(props);
	}

	static propTypes = {
		contextMenuItems: PropTypes.array,
		placement: PropTypes.string,
		align: PropTypes.string,
		triggerNode: PropTypes.object,
		style: PropTypes.object,
		domNodeToAttachTo: PropTypes.object,
		theme: PropTypes.bool,
		onClose: PropTypes.func,
		onChange: PropTypes.func
	};

	render () {
		const { theme, placement = 'bottomRight', align = 'left', domNodeToAttachTo = document.body, triggerNode, contextMenuItems, onClose, onChange } = this.props;

		if (!contextMenuItems || !contextMenuItems.length) {
			return;
		}

		return (
			<ContextMenu
				theme={theme}
				placement={placement}
				align={align}
				triggerNode={triggerNode}
				domNodeToAttachTo={domNodeToAttachTo}
				onClose={onClose}
				onChange={onChange}
				onClick={ (e) => {
					// TODO - is there a better way than this?
					// stop propagation of the click event out of context menu
					// this stops a click event from being registered on the parent element
					e.stopPropagation();
				} }
				onKeyDown={ (e) => {
					// stop propagation of the key event out of context menu
					// this stops a key event from being registered on the parent element
					e.stopPropagation();
				} }
			>
				{this._renderMenuItems(contextMenuItems)}
			</ContextMenu>
		);
	}

	_renderMenuItems(items) {
		if (items) {
			return items.map((section, index) => this._renderMenuSection(section, index));
		}
	}

	_renderMenuSection(section, key) {
		if (Array.isArray(section.items)) {
			const { name = 'menu', label, items } = section;

			return <ContextMenu.List
				key={key}
				content={items}
				name={name}
				label={label}
				clickSelection={true} />;
		} else {
			return <ContextMenu.Separator
				key={key}
			/>;
		}
	}
}



// WEBPACK FOOTER //
// ./src/js/dialog/schematic/ContextMenuWrapper.js